export type DocumentType = 'source' | 'target' | 'bilingual';

export const fileSizeLimitInMB = parseInt(process.env.REACT_APP_FILE_SIZE_LIMIT_MB || '0');
export const pageLimit = parseInt(process.env.REACT_APP_FILE_PAGE_LIMIT || '0');
export const wordLimit = parseInt(process.env.REACT_APP_FILE_WORD_LIMIT || '0');

export const errorTemplates: Record<string, string> = {
  'validation-service.too-many-pages': 'The {docType} exceeds {pageLimit}-page limit. Reduce pages and retry.',
  'validation-service.too-many-words': 'The {docType} exceeds {wordLimit}-word limit. Reduce words and retry.',
  'validation-service.file-format-not-supported': 'The {docType} file format is not supported, please upload a valid file.',
  'validation-service.file-too-large': 'The {docType} exceeds {fileSizeLimit}-MB limit. Reduce file size and retry.',
};

export const getErrorMessage = (errorCode: string): string => {
  const [prefix, type] = errorCode.split('_');
  const template = errorTemplates[prefix];

  if (!template) {
    return 'An unexpected error occurred.';
  }

  const isBilingual = type === 'bilingual';
  const effectivePageLimit = isBilingual ? pageLimit * 2 : pageLimit;
  const effectiveWordLimit = isBilingual ? wordLimit * 2 : wordLimit;
  const effectiveFileSizeLimit = fileSizeLimitInMB; // File size limit remains the same for all types

  return type
    ? template
        .replace('{docType}', type as DocumentType)
        .replace('{pageLimit}', effectivePageLimit.toString())
        .replace('{wordLimit}', effectiveWordLimit.toString())
        .replace('{fileSizeLimit}', effectiveFileSizeLimit.toString())
    : template;
};